import { useRouter } from 'next/router';
import React, { useCallback, useEffect, useState } from 'react';
import { DevelopmentLabel } from '~/components/developments/DevelopmentLabel';
import { envManager } from '~/constants/envManager';
import { useFeatureFlag } from '~/hooks/common/useFeatureFlag';

// demoドメインからdemo環境を取得するための正規表現
const DemoRegExp = /\.(demo[0-9]+)\./;
// 漏洩防止対策のため、ブランチ名を表示するページのリスト
const BrachLabelPages = ['/account', '/client', '/companies'] as const;

export const useEnvironmentViewer = () => {
  const featureFlag = useFeatureFlag();
  const [labelName, setLabelName] = useState('');
  const router = useRouter();

  useEffect(() => {
    if (envManager.publicEnv.environment === 'production' || !router.isReady) return;

    const isShowBranchName = BrachLabelPages.some((page) => router.pathname.startsWith(page));
    if (isShowBranchName) {
      setLabelName(envManager.publicEnv.gitBranchName);
    } else {
      const demoName = window.location.hostname.match(DemoRegExp)?.[1];
      setLabelName(demoName ?? envManager.publicEnv.environment);
    }
  }, [router]);

  const render = useCallback(() => {
    return (
      <>
        {envManager.publicEnv.environment !== 'production' && (
          <DevelopmentLabel labelName={labelName} flagList={featureFlag.state.activeFeatures} />
        )}
      </>
    );
  }, [featureFlag.state.activeFeatures, labelName]);

  return {
    render,
  };
};
